module.exports = __webpack_public_path__ + "static/media/SFMonoMedium.dd6296df.otf";